<template>
  <div>
    <v-card
      v-for="question in questions"
      :key="question.id"
      outlined
      class="mb-3 pa-3"
    >
      <div class="text-subtitle-2 mb-2">{{ question.prompt }}</div>

      <template v-if="question.type === 'open'">
        <v-textarea
          v-model="localAnswers[question.id].openValue"
          outlined
          dense
          rows="3"
          hide-details
          :disabled="disabled"
          placeholder="Sua resposta"
        />
      </template>

      <template v-else-if="question.type === 'single_choice'">
        <v-radio-group
          v-model="localAnswers[question.id].singleValue"
          hide-details
          :disabled="disabled"
        >
          <v-radio
            v-for="option in questionOptions(question)"
            :key="`${question.id}-${option}`"
            :label="option"
            :value="option"
          />
          <v-radio label="Outro..." :value="OTHER_VALUE" />
        </v-radio-group>
        <v-text-field
          v-if="localAnswers[question.id].singleValue === OTHER_VALUE"
          v-model="localAnswers[question.id].otherValue"
          label="Especifique"
          outlined
          dense
          hide-details
          class="mt-2"
          :disabled="disabled"
        />
      </template>

      <template v-else-if="question.type === 'multiple_choice'">
        <v-checkbox
          v-for="option in questionOptions(question)"
          :key="`${question.id}-${option}`"
          v-model="localAnswers[question.id].multipleValues"
          :label="option"
          :value="option"
          hide-details
          dense
          :disabled="disabled"
        />
        <v-checkbox
          v-model="localAnswers[question.id].otherSelected"
          label="Outro..."
          hide-details
          dense
          :disabled="disabled"
        />
        <v-text-field
          v-if="localAnswers[question.id].otherSelected"
          v-model="localAnswers[question.id].otherValue"
          label="Especifique"
          outlined
          dense
          hide-details
          class="mt-1"
          :disabled="disabled"
        />
      </template>
    </v-card>
  </div>
</template>

<script>
const OTHER_VALUE = "__other__";

export default {
  name: "FeatureAiQuestionForm",
  props: {
    questions: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      OTHER_VALUE,
      localAnswers: {},
    };
  },
  watch: {
    questions: {
      immediate: true,
      handler(questions) {
        const next = {};
        (questions || []).forEach((q) => {
          next[q.id] = {
            singleValue: null,
            multipleValues: [],
            otherSelected: false,
            otherValue: "",
            openValue: "",
          };
        });
        this.localAnswers = next;
      },
    },
  },
  methods: {
    questionOptions(question) {
      return (question.options || []).filter(Boolean);
    },
    buildAnswers() {
      return this.questions.map((question) => {
        const state = this.localAnswers[question.id] || {};

        if (question.type === "open") {
          return { id: question.id, values: state.openValue?.trim() || "" };
        }

        if (question.type === "single_choice") {
          let value = state.singleValue;
          if (value === OTHER_VALUE) {
            value = state.otherValue?.trim() || "";
          }
          return { id: question.id, values: value };
        }

        const values = [...(state.multipleValues || [])];
        if (state.otherSelected && state.otherValue?.trim()) {
          values.push(state.otherValue.trim());
        }
        return { id: question.id, values };
      });
    },
    validate() {
      for (const question of this.questions) {
        const answer = this.buildAnswers().find((a) => a.id === question.id);
        if (question.type === "open") {
          if (!answer.values?.trim()) return false;
          continue;
        }
        if (question.type === "single_choice") {
          if (!answer.values?.trim()) return false;
          continue;
        }
        if (!answer.values?.length) return false;
      }
      return true;
    },
  },
};
</script>
